import { Card } from 'antd';
import React, { FC, useMemo } from 'react';
import { AWARD_STATUSES } from '../../constants/BidderStatuses';
import { nullSafeGetOrElse, renderCurrency, roundOffToDecimal } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { TwoLineList } from '../two_line_list/TwoLineList';

const RFPTotalSpend: FC<any> = ({ bidders, currentUser }): React.ReactElement => {
	const awardedBidder = useMemo(
		() => bidders.find((_) => _.awardStatus === AWARD_STATUSES.Awarded),
		[bidders]
	);

	const awardedTotal = useMemo(
		() => parseFloat(nullSafeGetOrElse('proposal.totalAfterTax', awardedBidder, 0)),
		[awardedBidder]
	);

	const otherIncurredCost = useMemo(
		() =>
			bidders
				.filter((_) => _.awardStatus !== AWARD_STATUSES.Awarded)
				.map((_) => nullSafeGetOrElse('proposal.incurredCostTotalBeforeTax', _, 0))
				.map((_) => parseFloat(_))
				.reduce((acc, ic) => acc + ic, 0),
		[bidders]
	);

	const totalSpend = useMemo(
		() => roundOffToDecimal(awardedTotal + otherIncurredCost, 2),
		[awardedTotal, otherIncurredCost]
	);

	const details = useMemo(
		() => [
			{
				key: 'Awarded Total',
				value: awardedTotal,
			},
			{
				key: 'Other Incurred Costs',
				value: otherIncurredCost,
			},
		],
		[awardedTotal, otherIncurredCost]
	);

	return (
		<Card title="Total RFP Spend" extra={renderCurrency(currentUser)(totalSpend)}>
			<TwoLineList
				listItems={details}
				lineOneRender={(record) => renderCurrency(currentUser)(record.value)}
				lineTwoRender={(record) => record.key}
			/>
		</Card>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(RFPTotalSpend);
